import { SidebarItem, SidebarLink } from "@/types/types";

export const SidebarGenerator = (items: SidebarLink[]): SidebarItem[] => {
  return items.map(({ icon, label, path, isNew, id }) => ({
    icon,
    label,
    path: `/${path}`,
    isNew,
    id,
  }));
};
